import { Star, Award, Trophy, TrendingUp } from 'lucide-react';
import { useCopy } from '../../copy';

export function OppProfileAchievementsTab() {
  const { t } = useCopy();

  const BADGES = [
    { icon: Award, label: t('profile.badges.warm_writer') || '温暖写信人', unlocked: true, desc: '写下第一百封信' },
    { icon: Star, label: t('profile.badges.kind_courier') || '善意信使', unlocked: true, desc: '完成 20 次投递' },
    { icon: Trophy, label: t('profile.badges.museum_friend') || '馆藏伙伴', unlocked: false, desc: '有 10 封信进入博物馆' },
    { icon: TrendingUp, label: t('profile.badges.rising_writer') || '持续成长', unlocked: false, desc: '连续 30 天保持写作' },
  ];

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border border-[hsl(var(--opp-border))] bg-letter-amber-light p-5">
        <h3 className="font-serif text-lg font-bold text-[hsl(var(--opp-ink))]">{t('profile.achievements')}</h3>
        <p className="mt-1 text-sm text-[hsl(var(--opp-accent-strong))]">把你的写信、投递与收藏痕迹慢慢累积成独特徽章。</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {BADGES.map((badge) => {
          const Icon = badge.icon;
          return (
            <div
              key={badge.label}
              className={`rounded-xl border p-4 transition-colors ${
                badge.unlocked
                  ? 'border-[hsl(var(--opp-border))] bg-[hsl(var(--opp-surface-raised))]'
                  : 'border-[hsl(var(--opp-border))] bg-[hsl(var(--opp-surface-raised))]/60'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${badge.unlocked ? 'bg-[hsl(var(--opp-accent-soft))]' : 'bg-[hsl(var(--opp-accent-soft))]/60'}`}>
                  <Icon className={`h-5 w-5 ${badge.unlocked ? 'text-[hsl(var(--opp-accent-strong))]' : 'text-[hsl(var(--opp-muted))]'}`} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <p className={`text-sm font-semibold ${badge.unlocked ? 'text-[hsl(var(--opp-ink))]' : 'text-[hsl(var(--opp-muted))]'}`}>{badge.label}</p>
                    <span className={`rounded-full px-2 py-0.5 text-caption font-medium ${badge.unlocked ? 'bg-feedback-success/15 text-feedback-success' : 'bg-[hsl(var(--opp-accent-soft))] text-[hsl(var(--opp-muted))]'}`}>
                      {badge.unlocked ? '已解锁' : '未解锁'}
                    </span>
                  </div>
                  <p className="mt-1 text-xs leading-5 text-[hsl(var(--opp-accent-strong))]">{badge.desc}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
